import React, {useEffect} from "react";
import {useFormContext} from "react-hook-form";

import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import dayjs from 'dayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Autocomplete from '@mui/material/Autocomplete';

import * as DataPattern from '../../constants/DataPattern';
import * as CustomStyles from '../../styles/CustomStyles';
import * as ValidationMessages from '../../constants/ValidationMessages';
import * as SelectTypes from '../../constants/CustomSelectTypes';
import CustomSelect from '../../custom/CustomSelectComponent';
import {getEmployerSelectData, getWorksiteSelectData} from '../../util/TypeConvertor';
import * as RestCalls from '../../../utils/network/RestCalls'
import * as DateHelper from '../../util/DateHelper';


//
// It is expected that <FormProvider> provides all the hook methods in the parent before calling the below components
// The components access the methods (register, formState, errors, etc...) by using useFormContext()
// lEmployee is expected to be in the local form state
//

export function RenderPersonalDataSection() {
    console.log('Sectiune Date Personale...');
    const { register, setValue, formState: { errors, defaultValues } } = useFormContext();

    const [dateValue, setDateValue] = React.useState(dayjs(`${defaultValues.lEmployee.generalSection.dataNasterii}`));

    useEffect(() => {
        register('lEmployee..generalSection.dataNasterii', /*{required: ValidationMessages.REQUITED_MESSAGE}*/);
      }, [register]);


    const validateDobDate = (dataNasterii) => {
        if( DateHelper.isValidStringDateFmt(dataNasterii) ) {
            return true;
        }
        else {
            return 'Format data este invalid';
        }
    }


    return(
        <Box sx={CustomStyles.boxStyles}  >
            <Typography color="text.primary" paddingTop={1} paddingLeft={1}>Date Personale</Typography>

            <Grid container spacing={2} sx={CustomStyles.gridStyles}>
                {/*row*/}
                <Grid item xs={4}>
                    <TextField variant="standard" size="small" label="Nume" fullWidth margin="dense" 
                        {...register("lEmployee.generalSection.lastName", {required: ValidationMessages.REQUITED_MESSAGE})} 
                        error={!!errors?.lEmployee?.generalSection?.lastName}
                        helperText={errors?.lEmployee?.generalSection?.lastName ? errors.lEmployee.generalSection.lastName.message : null}
                    />
                </Grid>
                <Grid item xs={4}>
                    <TextField variant="standard" size="small" label="Prenume" fullWidth margin="dense" 
                        {...register("lEmployee.generalSection.firstName", {required: ValidationMessages.REQUITED_MESSAGE})} 
                        error={!!errors?.lEmployee?.generalSection?.firstName}
                        helperText={errors?.lEmployee?.generalSection?.firstName ? errors.lEmployee.generalSection.firstName.message : null}
                    />
                </Grid>
                <Grid item xs={1}>
                    <CustomSelect 
                        selectId={'sex'} 
                        selectType={SelectTypes.SEX_TYPE} 
                        value={defaultValues.lEmployee.generalSection.sexType} 
                        register={{...register('lEmployee.generalSection.sexType', {required: ValidationMessages.REQUITED_MESSAGE})}}
                        error={!!errors?.lEmployee?.generalSection?.sexType}
                        helperText={errors?.lEmployee?.generalSection?.sexType ? errors.lEmployee.generalSection.sexType.message : null}
                    />   
                </Grid>
                <Grid item xs={3}>
                </Grid>

                {/*row*/}
                <Grid item xs={3}>
                    <TextField variant="standard" size="small" label="Cod Numeric Personal" fullWidth margin="dense" 
                        {...register("lEmployee.generalSection.cnp", {required: ValidationMessages.REQUITED_MESSAGE})} 
                        error={!!errors?.lEmployee?.generalSection?.cnp}
                        helperText={errors?.lEmployee?.generalSection?.cnp ? errors.lEmployee.generalSection.cnp.message : null}
                    />
                </Grid>
                <Grid item xs={3}>
                    <TextField variant="standard" size="small" label="CI Nr." fullWidth margin="dense" 
                        {...register("lEmployee.generalSection.ciNo", {required: ValidationMessages.REQUITED_MESSAGE})} 
                        error={!!errors?.lEmployee?.generalSection?.ciNo}
                        helperText={errors?.lEmployee?.generalSection?.ciNo ? errors.lEmployee.generalSection.ciNo.message : null}
                    />
                </Grid>
                <Grid item xs={3}>
                    <TextField variant="standard" size="small" label="CI Serie" fullWidth margin="dense" 
                        {...register("lEmployee.generalSection.ciSeria", {required: ValidationMessages.REQUITED_MESSAGE})} 
                        error={!!errors?.lEmployee?.generalSection?.ciSeria}
                        helperText={errors?.lEmployee?.generalSection?.ciSeria ? errors.lEmployee.generalSection.ciSeria.message : null}
                    />
                </Grid>
                <Grid item xs={3}>
                    <CustomSelect 
                        selectId={'cetatenie'} 
                        selectType={SelectTypes.CETATENIE} 
                        value={defaultValues.lEmployee.generalSection.cetatenie} 
                        register={{...register('lEmployee.generalSection.cetatenie', {required: ValidationMessages.REQUITED_MESSAGE})}}
                        error={!!errors?.lEmployee?.generalSection?.cetatenie}
                        helperText={errors?.lEmployee?.generalSection?.cetatenie ? errors.lEmployee.generalSection.cetatenie.message : null}
                    />   
                </Grid>


                {/*row*/}
                <Grid item xs={4}>
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='ro'>
                        <DesktopDatePicker
                            label="Data Nasterii"
                            inputFormat={DataPattern.DATE_FORMAT_RO}
                            value={dateValue}
                            onChange={(newValue) => {
                                if(newValue && newValue.isValid()) {
                                    setDateValue(newValue);
                                    setValue('lEmployee.generalSection.dataNasterii', newValue.toISOString());
                                }
                            }}
                            renderInput={(params) => 
                                <TextField {...params} variant="standard" 
                                    {...register('lEmployee.generalSection.dataNasterii', 
                                        {required: ValidationMessages.REQUITED_MESSAGE,
                                        validate: vd => validateDobDate(vd)}
                                    )}
                                    error={!!errors?.lEmployee?.generalSection?.dataNasterii}
                                    helperText={errors?.lEmployee?.generalSection?.dataNasterii ? errors.lEmployee.generalSection.dataNasterii.message : null}
                                />}
                        />
                    </LocalizationProvider>
                </Grid>
                <Grid item xs={4}>
                    <TextField variant="standard" size="small" label="Locul Nasterii" fullWidth margin="dense" 
                        {...register("lEmployee.generalSection.loculNasterii", /*{required: ValidationMessages.REQUITED_MESSAGE}*/)} 
                        error={!!errors?.lEmployee?.generalSection?.loculNasterii}
                        helperText={errors?.lEmployee?.generalSection?.loculNasterii ? errors.lEmployee.generalSection.loculNasterii.message : null}
                    />
                </Grid>
                <Grid item xs={4}>
                </Grid>

                {/*row*/}
                <Grid item xs={4}>
                    <CustomSelect 
                        selectId={'stareaCivila'} 
                        selectType={SelectTypes.STARE_CIVILA} 
                        value={defaultValues.lEmployee.generalSection.stareaCivila} 
                        register={{...register('lEmployee.generalSection.stareaCivila', /*{required: ValidationMessages.REQUITED_MESSAGE}*/)}}
                        error={!!errors?.lEmployee?.generalSection?.stareaCivila}
                        helperText={errors?.lEmployee?.generalSection?.stareaCivila ? errors.lEmployee.generalSection.stareaCivila.message : null}
                    />   
                </Grid>
                <Grid item xs={4}>
                    <CustomSelect 
                        selectId={'persoaneInIntretinere'} 
                        selectType={SelectTypes.PERSOANE_INTRETINERE} 
                        value={defaultValues.lEmployee.generalSection.persoaneInIntretinere} 
                        register={{...register('lEmployee.generalSection.persoaneInIntretinere', /*{required: ValidationMessages.REQUITED_MESSAGE}*/)}}
                        error={!!errors?.lEmployee?.generalSection?.persoaneInIntretinere}
                        helperText={errors?.lEmployee?.generalSection?.persoaneInIntretinere ? errors.lEmployee.generalSection.persoaneInIntretinere.message : null}
                    />   
                </Grid>
                <Grid item xs={4}>
                    <TextField variant="standard" size="small" label="Nr Copii Minori" fullWidth margin="dense" 
                        {...register("lEmployee.generalSection.noCopiiMinori")} 
                    />
                </Grid>

            </Grid>
        </Box>
    );
}


export function RenderDomiciliuStabil() {
    console.log('Domiciliu Stabil...');
    const { register, formState: { errors, defaultValues } } = useFormContext();

    return(
        <Box sx={CustomStyles.boxStyles}  >
            <Typography color="text.primary" paddingTop={1} paddingLeft={1}>Domiciliu Stabil</Typography>

            <Grid container spacing={2} sx={CustomStyles.gridStyles}>
            {/*row*/}
            <Grid item xs={2}>
                <CustomSelect 
                    selectId={'mmJudet'} 
                    selectType={SelectTypes.JUDETE} 
                    value={defaultValues.lEmployee.domiciliuStabil.judet} 
                    register={{...register('lEmployee.domiciliuStabil.judet', /*{required: ValidationMessages.REQUITED_MESSAGE}*/)}}
                    error={!!errors?.lEmployee?.domiciliuStabil?.judet}
                    helperText={errors?.lEmployee?.domiciliuStabil?.judet ? errors.lEmployee?.domiciliuStabil?.judet.message : null}
                />   
            </Grid>
            <Grid item xs={3}>
                <TextField variant="standard" size="small" label="Localitate" fullWidth margin="dense" 
                    {...register("lEmployee.domiciliuStabil.localitate", /*{required: ValidationMessages.REQUITED_MESSAGE}*/)} 
                    error={!!errors?.lEmployee?.domiciliuStabil?.localitate}
                    helperText={errors?.lEmployee?.domiciliuStabil?.localitate ? errors.lEmployee?.domiciliuStabil?.localitate.message : null}
                />
            </Grid>
            <Grid item xs={0.75}>
                <TextField variant="standard" size="small" label="Sector" fullWidth margin="dense" 
                    {...register("lEmployee.domiciliuStabil.sector")} 
                    error={!!errors?.lEmployee?.domiciliuStabil?.sector}
                    helperText={errors?.lEmployee?.domiciliuStabil?.sector ? errors.lEmployee?.domiciliuStabil?.sector.message : null}
                />
            </Grid>
            <Grid item xs={4}>
                <TextField variant="standard" size="small" label="Strada" fullWidth margin="dense" 
                    {...register("lEmployee.domiciliuStabil.street", /*{required: ValidationMessages.REQUITED_MESSAGE}*/)} 
                    error={!!errors?.lEmployee?.domiciliuStabil?.street}
                    helperText={errors?.lEmployee?.domiciliuStabil?.street ? errors.lEmployee?.domiciliuStabil?.street.message : null}
                />
            </Grid>
            <Grid item xs={0.75}>
                <TextField variant="standard" size="small" label="Nr." fullWidth margin="dense" 
                    {...register("lEmployee.domiciliuStabil.no")} 
                    error={!!errors?.lEmployee?.domiciliuStabil?.no}
                    helperText={errors?.lEmployee?.domiciliuStabil?.no ? errors.lEmployee?.domiciliuStabil?.no.message : null}
                />
            </Grid>
            <Grid item xs={1.5}>
                <TextField variant="standard" size="small" label="Cod Postal" fullWidth margin="dense" 
                    {...register("lEmployee.domiciliuStabil.postalCode", /*{required: ValidationMessages.REQUITED_MESSAGE}*/)} 
                    error={!!errors?.lEmployee?.domiciliuStabil?.postalCode}
                    helperText={errors?.lEmployee?.domiciliuStabil?.postalCode ? errors.lEmployee?.domiciliuStabil?.postalCode.message : null}
                />
            </Grid>

            {/*row*/}
            <Grid item xs={2}>
                <TextField variant="standard" size="small" label="Bloc" fullWidth margin="dense" 
                    {...register("lEmployee.domiciliuStabil.bloc")} 
                    error={!!errors?.lEmployee?.domiciliuStabil?.bloc}
                    helperText={errors?.lEmployee?.domiciliuStabil?.bloc ? errors.lEmployee?.domiciliuStabil?.bloc.message : null}
                />
            </Grid>
            <Grid item xs={2}>
                <TextField variant="standard" size="small" label="Scara" fullWidth margin="dense" 
                    {...register("lEmployee.domiciliuStabil.scara")} 
                    error={!!errors?.lEmployee?.domiciliuStabil?.scara}
                    helperText={errors?.lEmployee?.domiciliuStabil?.scara ? errors.lEmployee?.domiciliuStabil?.scara.message : null}
                />
            </Grid>
            <Grid item xs={2}>
                <TextField variant="standard" size="small" label="Etaj" fullWidth margin="dense" 
                    {...register("lEmployee.domiciliuStabil.etaj")} 
                    error={!!errors?.lEmployee?.domiciliuStabil?.etaj}
                    helperText={errors?.lEmployee?.domiciliuStabil?.etaj ? errors.lEmployee?.domiciliuStabil?.etaj.message : null}
                />
            </Grid>
            <Grid item xs={2}>
                <TextField variant="standard" size="small" label="Apartament" fullWidth margin="dense" 
                    {...register("lEmployee.domiciliuStabil.apartment")} 
                    error={!!errors?.lEmployee?.domiciliuStabil?.apartment}
                    helperText={errors?.lEmployee?.domiciliuStabil?.apartment ? errors.lEmployee?.domiciliuStabil?.apartment.message : null}
                />
            </Grid>
            <Grid item xs={2}>
                <TextField variant="standard" size="small" label="Buzzer" fullWidth margin="dense" 
                    {...register("lEmployee.domiciliuStabil.buzzer")} 
                    error={!!errors?.lEmployee?.domiciliuStabil?.buzzer}
                    helperText={errors?.lEmployee?.domiciliuStabil?.buzzer ? errors.lEmployee?.domiciliuStabil?.buzzer.message : null}
                />
            </Grid>
            <Grid item xs={2}>
            </Grid>

            </Grid>
        </Box>
    );

}

    

export function RenderDomiciliuFlotant() {
    console.log('Domiciliu Flotant...');
    const { register, formState: { errors, defaultValues } } = useFormContext();

    return(
        <Box sx={CustomStyles.boxStyles}  >
            <Typography color="text.primary" paddingTop={1} paddingLeft={1}>Domiciliu Flotant</Typography>

            <Grid container spacing={2} sx={CustomStyles.gridStyles}>
            {/*row*/}
            <Grid item xs={2}>
                <CustomSelect 
                    selectId={'mmJudet'} 
                    selectType={SelectTypes.JUDETE} 
                    value={defaultValues.lEmployee.domiciliuFlotant.judet} 
                    register={{...register('lEmployee.domiciliuFlotant.judet')}}
                />   
            </Grid>
            <Grid item xs={3}>
                <TextField variant="standard" size="small" label="Localitate" fullWidth margin="dense" 
                    {...register("lEmployee.domiciliuFlotant.localitate")} 
                />
            </Grid>
            <Grid item xs={0.75}>
                <TextField variant="standard" size="small" label="Sector" fullWidth margin="dense" 
                    {...register("lEmployee.domiciliuFlotant.sector")} 
                />
            </Grid>
            <Grid item xs={4}>
                <TextField variant="standard" size="small" label="Strada" fullWidth margin="dense" 
                    {...register("lEmployee.domiciliuFlotant.street")} 
                />
            </Grid>
            <Grid item xs={0.75}>
                <TextField variant="standard" size="small" label="Nr." fullWidth margin="dense" 
                    {...register("lEmployee.domiciliuFlotant.no")} 
                />
            </Grid>
            <Grid item xs={1.5}>
                <TextField variant="standard" size="small" label="Cod Postal" fullWidth margin="dense" 
                    {...register("lEmployee.domiciliuFlotant.postalCode")} 
                />
            </Grid>

            {/*row*/}
            <Grid item xs={2}>
                <TextField variant="standard" size="small" label="Bloc" fullWidth margin="dense" 
                    {...register("lEmployee.domiciliuFlotant.bloc")} 
                    error={!!errors?.lEmployee?.domiciliuFlotant?.bloc}
                    helperText={errors?.lEmployee?.domiciliuFlotant?.bloc ? errors.lEmployee?.domiciliuFlotant?.bloc.message : null}
                />
            </Grid>
            <Grid item xs={2}>
                <TextField variant="standard" size="small" label="Scara" fullWidth margin="dense" 
                    {...register("lEmployee.domiciliuFlotant.scara")} 
                    error={!!errors?.lEmployee?.domiciliuFlotant?.scara}
                    helperText={errors?.lEmployee?.domiciliuFlotant?.scara ? errors.lEmployee?.domiciliuFlotant?.scara.message : null}
                />
            </Grid>
            <Grid item xs={2}>
                <TextField variant="standard" size="small" label="Etaj" fullWidth margin="dense" 
                    {...register("lEmployee.domiciliuFlotant.etaj")} 
                    error={!!errors?.lEmployee?.domiciliuFlotant?.etaj}
                    helperText={errors?.lEmployee?.domiciliuFlotant?.etaj ? errors.lEmployee?.domiciliuFlotant?.etaj.message : null}
                />
            </Grid>
            <Grid item xs={2}>
                <TextField variant="standard" size="small" label="Apartament" fullWidth margin="dense" 
                    {...register("lEmployee.domiciliuFlotant.apartment")} 
                    error={!!errors?.lEmployee?.domiciliuFlotant?.apartment}
                    helperText={errors?.lEmployee?.domiciliuFlotant?.apartment ? errors.lEmployee?.domiciliuFlotant?.apartment.message : null}
                />
            </Grid>
            <Grid item xs={2}>
                <TextField variant="standard" size="small" label="Buzzer" fullWidth margin="dense" 
                    {...register("lEmployee.domiciliuFlotant.buzzer")} 
                    error={!!errors?.lEmployee?.domiciliuFlotant?.buzzer}
                    helperText={errors?.lEmployee?.domiciliuFlotant?.buzzer ? errors.lEmployee?.domiciliuFlotant?.buzzer.message : null}
                />
            </Grid>
            <Grid item xs={2}>
            </Grid>

            </Grid>
        </Box>
    );
}


export function RenderEmployment(props) {
    console.log('___Employment Section___');
    const { register, setValue, formState: { errors, defaultValues } } = useFormContext();

    useEffect(() => {
        if(!!defaultValues.lEmployee.employmentDetails.employerId) {
            loadAndSetSelectedWorksite();
        }
    }, []);

    const [currentWorkContractDate, setCurrentWorkContactDate] = React.useState(dayjs(`${defaultValues.lEmployee.employmentDetails.currentWorkContractDate}`));
    const [workingSinceDate, setWorkingSinceDate] = React.useState(dayjs(`${defaultValues.lEmployee.employmentDetails.wokingSince}`));
    const [currentOccupationSinceDate, setCurrentOccupationSinceDate] = React.useState(dayjs(`${defaultValues.lEmployee.employmentDetails.currentOccupationSince}`));
    const [currentEmployerSinceDate, setCurrentEmployerSinceDate] = React.useState(dayjs(`${defaultValues.lEmployee.employmentDetails.currentEmployerSince}`));

    const [selectedEmployerId, setSelectedEmployerId] = React.useState( defaultValues.lEmployee.employmentDetails.employerId!=null ? defaultValues.lEmployee.employmentDetails.employerId : '' );
    const [selectedWorksiteId, setSelectedWorksiteId] = React.useState('');
    const [worksites, setWorksites] = React.useState([]);

    const [checkedCMT, setCheckedCMT] = React.useState(!!defaultValues.lEmployee.employmentDetails.cmt ? defaultValues.lEmployee.employmentDetails.cmt: false);
    const [checkedHasDisabilities, setCheckedHasDisabilities] = React.useState(!!defaultValues.lEmployee.employmentDetails.hasDisabilities ? defaultValues.lEmployee.employmentDetails.hasDisabilities: false);


    const [optionValue, setOptionValue] = React.useState( 
        defaultValues.lEmployee.employmentDetails.occupationCOR ? props.corCodes.filter((corCod) => corCod.cod === defaultValues.lEmployee.employmentDetails.occupationCOR)[0] : null 
    );
    // const [inputValue, setInputValue] = React.useState('');

    const employerSelectData = getEmployerSelectData(props.employers);
    const worksiteSelectData = getWorksiteSelectData(selectedEmployerId, worksites, false);


    const loadAndSetSelectedWorksite = async () => {
        await loadWorksitesForEmployer(defaultValues.lEmployee.employmentDetails.employerId);
        setSelectedWorksiteId(defaultValues.lEmployee.employmentDetails.workSiteId);
    }

    const loadWorksitesForEmployer = async (employerId) => {
        const ddbWs = await RestCalls.fetchEmployerWorksites(employerId)
                .catch(error => console.log(error)); 

        setWorksites(ddbWs);
    }

    return(
        <Box sx={CustomStyles.boxStyles}  >
            <Typography color="text.primary" paddingTop={1} paddingLeft={1}>Datele de Angajare</Typography>

            <Grid container spacing={2} sx={CustomStyles.gridStyles}>
            {/*row*/}
            <Grid item xs={4}>
                <FormControl fullWidth size="small" margin="dense" variant="standard" disabled={!!defaultValues.lEmployee.id}>
                    <InputLabel id={'daAngajator-inputLabelId'} error={!!errors?.lEmployee?.employmentDetails?.employerId}>Angajator</InputLabel>
                    <Select
                        {...register('lEmployee.employmentDetails.employerId', {required: ValidationMessages.REQUITED_MESSAGE})}
                        labelId={'daAngajator-selectLabelId'}
                        id={'daAngajator'}
                        value={selectedEmployerId}
                        onChange={(event) => {
                            setSelectedEmployerId(event.target.value);
                            setSelectedWorksiteId('');
                            loadWorksitesForEmployer(event.target.value);
                        }}
                        label={'daAngajator-label'}
                        error={!!errors?.lEmployee?.employmentDetails?.employerId}
                        >
                        {
                            employerSelectData.map((data) => <MenuItem dense value={data.id} key={data.id}> {data.name} </MenuItem>)
                        }
                    </Select>
                    <Typography sx={{ color: 'error.main', fontSize: 12 }}>{errors?.lEmployee?.employmentDetails?.employerId ? errors.lEmployee.employmentDetails.employerId.message : null}</Typography>
                </FormControl>
            </Grid>
            <Grid item xs={4}>
                <FormControl fullWidth size="small" margin="dense" variant="standard">
                    <InputLabel id={'daWorkSite-inputLabelId'} error={!!errors?.lEmployee?.employmentDetails?.workSiteId}>Punct de Lucru</InputLabel>
                    <Select
                        {...register('lEmployee.employmentDetails.workSiteId', {required: ValidationMessages.REQUITED_MESSAGE})}
                        labelId={'daWorkSite-selectLabelId'}
                        id={'daWorkSite'}
                        value={selectedWorksiteId}
                        onChange={(event) => setSelectedWorksiteId(event.target.value)}
                        label={'daWorkSite-label'}
                        error={!!errors?.lEmployee?.employmentDetails?.workSiteId}
                        >
                        {
                            worksiteSelectData.map((data) => <MenuItem dense value={data.id} key={data.id}> {data.name} </MenuItem>)
                        }
                    </Select>
                    <Typography sx={{ color: 'error.main', fontSize: 12 }}>{errors?.lEmployee?.employmentDetails?.workSiteId ? errors.lEmployee?.employmentDetails?.workSiteId.message : null}</Typography>
                </FormControl>
            </Grid>
            <Grid item xs={4}>
            </Grid>

            {/**/}
            <Grid item xs={8}>
                <Autocomplete
                    id="cor-code-autocomplete"
                    options={props.corCodes}
                    getOptionLabel={(option) => option.cod + ' - ' + option.description}
                    value={optionValue}
                    onChange={(event, newValue) => {
                        setOptionValue(newValue);
                        setValue("lEmployee.employmentDetails.occupationCOR", newValue?.cod);
                    }}
                    // inputValue={inputValue}
                    // onInputChange={(event, newInputValue) => setInputValue(newInputValue) }
                    renderInput={(params) => (
                        <TextField {...params} variant="standard" size="small" fullWidth margin="dense" label="Ocupatia (COR)" 
                            {...register("lEmployee.employmentDetails.occupationCORdescription", {required: ValidationMessages.REQUITED_MESSAGE})} 
                            error={!!errors?.lEmployee?.employmentDetails?.occupationCORdescription}
                            helperText={errors?.lEmployee?.employmentDetails?.occupationCORdescription ? errors.lEmployee?.employmentDetails?.occupationCORdescription.message : null}
                        />
                    )}
                />
            </Grid>
            <Grid item xs={4}>
            </Grid>

            {/**/}
            <Grid item xs={4}>
                <CustomSelect 
                    selectId={'employeeContractStatus'} 
                    selectType={SelectTypes.EMPLOYEE_CONTRACT_STATUS} 
                    value={defaultValues.lEmployee.employmentDetails.contractStatus} 
                    register={{...register('lEmployee.employmentDetails.contractStatus', {required: ValidationMessages.REQUITED_MESSAGE})}}
                    error={!!errors?.lEmployee?.employmentDetails?.contractStatus}
                    helperText={errors?.lEmployee?.employmentDetails?.contractStatus ? errors.lEmployee?.employmentDetails?.contractStatus.message : null}
                />   
            </Grid>
            <Grid item xs={4}>
                <FormControlLabel sx={{marginLeft: 2, marginTop: 2}}
                    control={ 
                        <Checkbox 
                            {...register('lEmployee.employmentDetails.cmt')}                         
                            checked={checkedCMT} 
                            onChange={(event) => setCheckedCMT(event.target.checked)}
                        /> 
                    } 
                    label="CMT" 
                />
            </Grid>
            <Grid item xs={4}>
                <TextField variant="standard" size="small" label="Angajator CMT" fullWidth margin="dense" 
                    {...register("lEmployee.employmentDetails.angajatorCMT")} 
                    error={!!errors?.lEmployee?.employmentDetails?.angajatorCMT}
                    helperText={errors?.lEmployee?.employmentDetails?.angajatorCMT ? errors.lEmployee?.employmentDetails?.angajatorCMT.message : null}
                />
            </Grid>

            {/*row*/}
            <Grid item xs={4}>
                <TextField variant="standard" size="small" label="Numar Contract de Munca (RGES)" fullWidth margin="dense" 
                    {...register("lEmployee.employmentDetails.contractMuncaNo", /*{required: ValidationMessages.REQUITED_MESSAGE}*/)} 
                    error={!!errors?.lEmployee?.employmentDetails?.contractMuncaNo}
                    helperText={errors?.lEmployee?.employmentDetails?.contractMuncaNo ? errors.lEmployee?.employmentDetails?.contractMuncaNo.message : null}
                />
            </Grid>
            <Grid item xs={4}>

                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='ro'>
                    <DesktopDatePicker
                        label="Data Contract de Munca"
                        inputFormat={DataPattern.DATE_FORMAT_RO}
                        value={currentWorkContractDate}
                        onChange={(newValue) => {
                            setCurrentWorkContactDate(newValue);
                            setValue('lEmployee.employmentDetails.currentWorkContractDate', newValue);
                        }}
                        renderInput={(params) => 
                            <TextField {...params} variant="standard" id="vechime_in_ocupatie"
                                {...register('lEmployee.employmentDetails.currentWorkContractDate')}
                                error={!!errors?.lEmployee?.employmentDetails?.currentWorkContractDate}
                                helperText={errors?.lEmployee?.employmentDetails?.currentWorkContractDate ? errors.lEmployee.employmentDetails.currentWorkContractDate.message : null}
                            />}
                />
                </LocalizationProvider>
            </Grid>
            <Grid item xs={4}>
            </Grid>
            
            {/*row*/}
            <Grid item xs={4}>
                <CustomSelect 
                    selectId={'durataMuncii'} 
                    selectType={SelectTypes.DURATA_MUNCII} 
                    value={defaultValues.lEmployee.employmentDetails.durataMuncii} 
                    register={{...register('lEmployee.employmentDetails.durataMuncii', /*{required: ValidationMessages.REQUITED_MESSAGE}*/)}}
                    error={!!errors?.lEmployee?.employmentDetails?.durataMuncii}
                    helperText={errors?.lEmployee?.employmentDetails?.durataMuncii ? errors.lEmployee?.employmentDetails?.durataMuncii.message : null}
                />   
            </Grid>
            <Grid item xs={4}>
                <CustomSelect 
                    selectId={'statutProfesional'} 
                    selectType={SelectTypes.STATUT_PROFESIONAL} 
                    value={defaultValues.lEmployee.employmentDetails.statutProfesional} 
                    register={{...register('lEmployee.employmentDetails.statutProfesional', /*{required: ValidationMessages.REQUITED_MESSAGE}*/)}}
                    error={!!errors?.lEmployee?.employmentDetails?.statutProfesional}
                    helperText={errors?.lEmployee?.employmentDetails?.statutProfesional ? errors.lEmployee?.employmentDetails?.statutProfesional.message : null}
                />   
            </Grid>
            <Grid item xs={4}>
                <TextField variant="standard" size="small" label="Nr. Contract Asigurare" fullWidth margin="dense" 
                    {...register("lEmployee.employmentDetails.contractAsigurareNo", /*{required: ValidationMessages.REQUITED_MESSAGE}*/)} 
                    error={!!errors?.lEmployee?.employmentDetails?.contractAsigurareNo}
                    helperText={errors?.lEmployee?.employmentDetails?.contractAsigurareNo ? errors.lEmployee?.employmentDetails?.contractAsigurareNo.message : null}
                />

            </Grid>

            {/*row*/}
            <Grid item xs={4}>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='ro'>
                    <DesktopDatePicker
                        label="Vechime in Munca"
                        inputFormat={DataPattern.DATE_FORMAT_RO}
                        value={workingSinceDate}
                        onChange={(newValue) => {
                            setWorkingSinceDate(newValue);
                            setValue('lEmployee.employmentDetails.wokingSince', newValue);
                        }}
                        renderInput={(params) => 
                            <TextField {...params} variant="standard" id="vechime_in_munca"
                                {...register('lEmployee.employmentDetails.wokingSince')}
                                error={!!errors?.lEmployee?.employmentDetails?.wokingSince}
                                helperText={errors?.lEmployee?.employmentDetails?.wokingSince ? errors.lEmployee.employmentDetails.wokingSince.message : null}
                            />}
                    />
                </LocalizationProvider>
            </Grid>
            <Grid item xs={4}>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='ro'>
                    <DesktopDatePicker
                        label="Vechime in Ocupatie"
                        inputFormat={DataPattern.DATE_FORMAT_RO}
                        value={currentOccupationSinceDate}
                        onChange={(newValue) => {
                            console.log('New date: ' + JSON.stringify(newValue))
                            setCurrentOccupationSinceDate(newValue);
                            setValue('lEmployee.employmentDetails.currentOccupationSince', newValue);
                        }}
                        renderInput={(params) => 
                            <TextField {...params} variant="standard" id="vechime_in_ocupatie"
                                {...register('lEmployee.employmentDetails.currentOccupationSince')}
                                error={!!errors?.lEmployee?.employmentDetails?.currentOccupationSince}
                                helperText={errors?.lEmployee?.employmentDetails?.currentOccupationSince ? errors.lEmployee.employmentDetails.currentOccupationSince.message : null}
                            />}
                    />
                </LocalizationProvider>
            </Grid>
            <Grid item xs={4}>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='ro'>
                    <DesktopDatePicker
                        label="Vechime la locul de Munca"
                        inputFormat={DataPattern.DATE_FORMAT_RO}
                        value={currentEmployerSinceDate}
                        onChange={(newValue) => {
                            setCurrentEmployerSinceDate(newValue);
                            setValue('lEmployee.employmentDetails.currentEmployerSince', newValue);
                        }}
                        renderInput={(params) => 
                            <TextField {...params} variant="standard" size="medium"
                                {...register('lEmployee.employmentDetails.currentEmployerSince')}
                                error={!!errors?.lEmployee?.employmentDetails?.currentEmployerSince}
                                helperText={errors?.lEmployee?.employmentDetails?.currentEmployerSince ? errors.lEmployee.employmentDetails.currentEmployerSince.message : null}
                            />}
                    />
                </LocalizationProvider>
            </Grid>


            {/*row*/}
            <Grid item xs={4}>
            <FormControlLabel 
                    control={ 
                        <Checkbox
                            {...register('lEmployee.employmentDetails.hasDisabilities')}                         
                            checked={checkedHasDisabilities} 
                            onChange={(event) => setCheckedHasDisabilities(event.target.checked)}
                        /> 
                    } 
                    label="Persoana cu handicap" 
                />
            </Grid>
            <Grid item xs={8}>
            </Grid>

            </Grid>

        </Box>
    );
}
